import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
    getBillingDetails,
    submitBillingDetails,
    getBillingDetailsLoadState,
    getBillingDetailsErros,
    getBillingDetailsRequestLoadState,
} from './billing-details.state';

export const withBillingDetails = connect(state => ({
    billingDetails: getBillingDetails(state),
    billingDetailsErros: getBillingDetailsErros(state),
    billingDetailsLoadState: getBillingDetailsLoadState(state),
    billingDetailsRequestLoadState: getBillingDetailsRequestLoadState(state),
}),
dispatch => bindActionCreators({
    onSubmitBillingDetails: submitBillingDetails,
}, dispatch));
